"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // (C) 2007-2018 GoodData Corporation

var routes = __importStar(require("./routes"));

var ContractsModule =
/** @class */
function () {
  function ContractsModule(xhr) {
    this.xhr = xhr;
  }

  ContractsModule.prototype.getUserContracts = function () {
    return this.xhr.get(routes.CONTRACTS).then(function (data) {
      return {
        items: data.getData().contracts.items.map(function (item) {
          return item.contract;
        }),
        paging: data.getData().contracts.paging
      };
    });
  };

  return ContractsModule;
}();

exports.ContractsModule = ContractsModule;